import { t, type MessageKey } from '../i18n/index.ts';
import type { SeriesKey } from '../lib/model.ts';
import { Segmented } from './ui.tsx';

export const TIMEFRAMES = [5, 10, 20, 25, 50] as const;

export function TimeframePicker({ value, onChange, options = TIMEFRAMES, size = 'md', variant = 'tabs' }: {
  value: number;
  onChange: (years: number) => void;
  options?: readonly number[];
  size?: 'sm' | 'md';
  variant?: 'tabs' | 'boxed';
}) {
  return (
    <Segmented
      label={t('forecast.timeframe')}
      options={options.map((y) => ({ value: y, label: t('common.years', { n: y }) }))}
      value={value}
      onChange={onChange}
      size={size}
      variant={variant}
    />
  );
}

export const SERIES: readonly { key: SeriesKey; label: MessageKey }[] = [
  { key: 'cash', label: 'forecast.series.cash' },
  { key: 'investment', label: 'forecast.series.investment' },
  { key: 'equity', label: 'forecast.series.equity' },
  { key: 'debt', label: 'forecast.series.debt' },
  { key: 'netWorth', label: 'forecast.series.netWorth' },
];

export function SeriesChips({ visible, onToggle, wrap = false }: { visible: ReadonlySet<SeriesKey>; onToggle: (key: SeriesKey) => void; wrap?: boolean }) {
  return (
    <div role="group" aria-label={t('forecast.series')} className={`series-chips ${wrap ? 'series-chips--wrap' : ''}`}>
      {SERIES.map((s) => (
        <button
          key={s.key}
          type="button"
          aria-pressed={visible.has(s.key)}
          className={`series-chip series-chip--${s.key}`}
          onClick={() => onToggle(s.key)}
        >
          {t(s.label)}
        </button>
      ))}
    </div>
  );
}

export const ALL_SERIES: ReadonlySet<SeriesKey> = new Set(SERIES.map((s) => s.key));

export function toggleSeries(set: ReadonlySet<SeriesKey>, key: SeriesKey): ReadonlySet<SeriesKey> {
  const next = new Set(set);
  if (next.has(key)) {
    if (next.size > 1) next.delete(key);
  } else next.add(key);
  return next;
}
